import { render, staticRenderFns } from "./ExcelError.vue?vue&type=template&id=45356fe2&scoped=true&"
import script from "./ExcelError.vue?vue&type=script&lang=js&"
export * from "./ExcelError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45356fe2",
  null
  
)

export default component.exports